import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Agents Layout Route
 * 
 * Layout route for all agent-related pages.
 * This file is required by TanStack Router when there are child routes.
 */
function AgentsLayout() {
  return <Outlet />;
}

export const Route = createFileRoute('/agents')({
  component: AgentsLayout,
});
